<template>
    <!-- 分页组件 -->
    <el-pagination
    :hide-on-single-page="hide"
    :background="background"
    :small="small"
    :current-page="page"
    :page-sizes="pageSizes"
    :page-size="size"
    :total="total"
    :layout="layout"
    :page-count="pageCount"
    :pager-count="pagerCount"
    :prev-text="prevText"
    :next-text="nextText"
    :disabled="disabled"
    @size-change="sizeChange"
    @current-change="pageChange"
    />
</template>
<script>
export default {
    name:"VelPagination",
    props:{
        size:Number,
        pageSizes:{
            type:Array,
            default:() =>{
                return [20,50,100,200]
            }
        },
        page:Number,
        layout:{
            type:String,
            default:'total, sizes, prev, pager, next, jumper'
        },
        total:Number,
        pageCount:Number,
        pagerCount:Number,
        prevText:String,
        nextText:String,
        isDisable:Boolean,
        isHide:Boolean,
        isBackground:Boolean,
        isSmall:Boolean,
    },
    data() {
        return {
            disabled:false,
            hide:false,
            background:true,
            small:false,
        };
    },
    created() {
        this.initDataFn()
    },
    methods: {
        initDataFn(){
            this.isDisable ? this.disabled = true : this.disabled
            this.isHide ? this.hide = true : this.hide
            this.isBackground ? this.background = false : this.background
            this.isSmall ? this.small = true : this.small
        },
        sizeChange(val) {
            this.$emit('paginationFn','size',val)
        },
        pageChange(val) {
            this.$emit('paginationFn','page',val)
        }
    }
}
</script>